// extracted by mini-css-extract-plugin
module.exports = {"adornmentIconContainer":"styles_adornmentIconContainer__jbNm7","defaultCursor":"styles_defaultCursor__1QkSV","pointerCursor":"styles_pointerCursor__3WtEA"};